var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('v-row',{attrs:{"justify":"start","no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-skeleton-loader',_vm._b({attrs:{"type":"card-heading, divider, list-item-three-line, divider, image, divider, card-heading, list-item@12"}},'v-skeleton-loader',_vm.attrs,false))],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }